import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Form from './components/Form';
import Error from './components/Error';
import Weather from './components/Weather';

function App() {

  // State principal
  // city =state
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [error, setError] = useState(false);
  const [resultApi , setResultApi] = useState({});

  useEffect(() => {
    //prevenir ejecucion
    if(city ===''){
      return;
    }
    consultAPI();
    //eslint-disable-next-line
  }, [city, country]);

  const consultAPI = async () => {
    const appId = '4ca7c588a233b05bb7975951388cd965';
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${appId}`;

    const response = await fetch(url);
    const result = await response.json();
    console.log(result);
    setResultApi(result);
  }

  const consultData = result => {
    if (result.city === '' || result.country === '') {
      //an error
      setError(true);
      console.log(result.city);
      console.log(result.country);
      return;
    }
    console.log(result);
    //ciudad y pais existen agregarlos al state
    setCity(result.city);
    setCountry(result.country);
    setError(false);
  }




  // Cargar un componente condicionalmente
  let component;
  if (error) {
    // hay error momstrar
    component = <Error message='Ambos campos son obligatorios' />
  }
  else if  (resultApi.cod==="404"){
    component= <Error message='La ciudad no existe en nuestro registro' />
  }
  else {
    //mostrar el clima
    component = <Weather
                  resultApi={resultApi}
                />;
  }


  return (
    <div className="App">
      <Header
        title='Luis Torres Clima'
      />
      <div className="contenedor-form">
        <div className="container">
          <div className="row">
            <div className="col s12 m6">
              <Form
                consultData={consultData}
              />
            </div>
            <div className="col s12 m6">
              {component}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
